import type { RegisteredActivityName } from '@stackflow/config';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useAuthFlow(flows?: {
    activityName: RegisteredActivityName,
    activityParams: object,
}[]) {
    const [_, setCookie, removeCookie] = useCookies(['authFlow']);
    useEffect(() => {
        if (flows) {
            setCookie('authFlow', JSON.stringify(flows), { path: '/', maxAge: 60 * 60 });
        } else {
            removeCookie('authFlow');
        }
    }, [flows]);
}

export default useAuthFlow;
